import axios from "axios";

export default function getBallots() {
    // const fetchOptions = {
    //     method: 'POST'
    // }

    return dispatch => {
        let url = `https://us-central1-fantasy-football-fyg.cloudfunctions.net/get-ballots`;
        return axios.post(url,{})
                     .then(res => {
                            dispatch({
                                type: "get_ballots_suc",
                                payload: res.data
                            })
                     }).catch(error => {
                            console.log(error);
                     });
    }
}


